import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss']
})
export class VouchersComponent implements OnInit {
  voucherForm: FormGroup;
  appShopId: any;
  vouchers: any;
  deleteVoucherId: any;
  imgurl: string;
  isEditVoucher: boolean;
  selectedvoucher: any;
  @ViewChild('exampleModalCenter') modal: any;
  private modalRef: any;
  redeemHistory: any = [];

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal

  ) { }

  ngOnInit(): void {
    this.initForm()
    this.imgurl = environment.ImageUrl
    this.route.params.subscribe(params => {
      this.appShopId = params['id'];
    });
    this.getAllVouchers()
    
  }

  initForm() {
    this.voucherForm = this.formBuilder.group({
      voucherName: ['', Validators.required],
      voucherDescription: ['', Validators.required],
      points_required: ['', [Validators.required, Validators.pattern(/^-?\d+$/)]],
      voucherCode: ['', [Validators.required]],
      voucherValidity: ['', [Validators.required]],
      voucherType: ['Gold', Validators.required],
      voucherImage: [null]
    });
  }

  getAllVouchers() {
    this.authService.getAllVouchers(this.appShopId).subscribe((res) => {
      this.vouchers = res['body']
      this.addActiveStatusToVouchers();
    })
  }

  get f() { return this.voucherForm.controls; }

  onFileChange(event) {
    const file = event.target.files[0];

    this.voucherForm.patchValue({
      voucherImage: file
    });
  }

  onSubmit() {
    this.voucherForm.markAllAsTouched()
    if (this.voucherForm.invalid) {
      return;
    }
    if (this.isEditVoucher) {
      const formData = new FormData();
      formData.append('voucherName', this.voucherForm.value.voucherName);
      formData.append('voucherDescription', this.voucherForm.value.voucherDescription);
      formData.append('points_required', this.voucherForm.value.points_required);
      formData.append('voucherCode', this.voucherForm.value.voucherCode);
      const voucherValidityDateString = this.voucherForm.value.voucherValidity;
      const voucherValidityTimestamp = (new Date(voucherValidityDateString).getTime())/1000;
      formData.append('voucherValidity', voucherValidityTimestamp.toString());
      formData.append('image', this.voucherForm.value.voucherImage);
      formData.append('voucherType', this.voucherForm.value.voucherType);
      formData.append('shopId', this.appShopId);
      this.authService.updateVoucher(formData, this.selectedvoucher.id).subscribe((res) => {
        this.toastr.success('Voucher Updated Successfully')
        this.getAllVouchers()
      })
    }
    else {
      const formData = new FormData();
      formData.append('voucherName', this.voucherForm.value.voucherName);
      formData.append('voucherDescription', this.voucherForm.value.voucherDescription);
      formData.append('points_required', this.voucherForm.value.points_required);
      formData.append('voucherCode', this.voucherForm.value.voucherCode);
      const voucherValidityDateString = this.voucherForm.value.voucherValidity;
      const voucherValidityTimestamp = (new Date(voucherValidityDateString).getTime())/1000;
      // Now you can append the timestamp to formData
      formData.append('voucherValidity', voucherValidityTimestamp.toString());
      formData.append('image', this.voucherForm.value.voucherImage);
      formData.append('voucherType', this.voucherForm.value.voucherType);
      formData.append('shopId', this.appShopId);
      this.authService.createVoucher(formData).subscribe((res) => {
        this.toastr.success('Voucher Created Successfully')
        this.getAllVouchers()
      })
    }
  }

  deleteVoucher() {
    this.authService.deleteVoucher(this.deleteVoucherId).subscribe((res) => {
      this.getAllVouchers()
    })
  }

  onDeleteVoucher(id) {
    this.deleteVoucherId = id
  }

  onClickEdit(voucherData) {
    this.voucherForm.reset()
    this.isEditVoucher = true
    this.selectedvoucher = voucherData
    const voucherValidityDate = new Date(this.selectedvoucher.voucherValidity*1000);

    this.voucherForm.patchValue({
      voucherName: voucherData.voucherName,
      voucherDescription: voucherData.voucherDescription,
      points_required: voucherData.points_required,
      voucherCode: voucherData.voucherCode,
      voucherType: voucherData.voucherType,
      voucherValidity: voucherValidityDate.toISOString().split('T')[0]
    });

  }
  dismissModal() {
    const modalRef = this.modalService.dismissAll();
  }

  openModalef(modal) {
    this.modalRef = this.modalService.open(modal)
  }

  addActiveStatusToVouchers(): void {
    const currentDate = new Date().getTime(); // Current date in milliseconds

    this.vouchers.forEach(voucher => {
      const voucherValidityTimestamp = voucher.voucherValidity * 1000; // Convert to milliseconds
      voucher.active = voucherValidityTimestamp > currentDate;
    });
    
  }
  @ViewChild('redeemHistoryModal') redeemHistoryModal: any;
  onClickHistory(item){

    this.redeemHistory = item.redemptionHistory
    if(this.redeemHistory.length){
      this.redeemHistory.sort((a,b)=>{
        return a.redeemedAt - b.redeemedAt
      })
      this.modalRef = this.modalService.open(this.redeemHistoryModal,{ size: 'sm',ariaLabelledBy: 'modal-basic-title', windowClass: 'redeemHistoryModal' });
    }
    
  }
  

}
